"use client"; 

import { useState } from 'react'

import FilterBubbles from '../generic/filterBubbles'
import AutomationsGrid from '../automations/automationsGrid'


export default function AppAutomationsBlock({ externalAutomations }) {

   // FILTER EXT AUTOMATIONS 
   const [selectedSourceAut, setSelectedSourceAut] = useState<any>(null)
   const externalAutomationsFiltered = (selectedSourceAut?.slug==='all' || !selectedSourceAut) ?  externalAutomations : externalAutomations?.filter(a => a?.source?.id === selectedSourceAut?.id)
   const sourcesListAut = externalAutomations?.map(item => item?.source)  // sources from all externalAutomations plin, with diplications 
   const sourcesUniqueAut = [...new Set(externalAutomations?.map(item => item?.source?.id))]?.map(id => sourcesListAut.find(s => s.id === id))  // uniq sources 
   let filterSourcesAut = sourcesUniqueAut?.map(item => ({
     ...item, 
     count: sourcesListAut?.filter(s => s.id === item.id)?.length
   }))?.sort((a, b) => a.order-b.order)  // with counter and sorted by this counter// was b.count - a.count

   
  return (      
    <div className="">
      
      {/* Ext Automations filters - by Source */}
      <div className="bg-gray-100 rounded ">
        <div className="mt-4">
          <FilterBubbles 
            items={filterSourcesAut} 
            selectedItem={selectedSourceAut} 
            setSelectedItem={setSelectedSourceAut}             
            filterTitle='Integrates via' 
            chunk={20}
            chunkInitial={5}
          />
        </div>
      </div>

      
      <div className='pt-3 '>
        <AutomationsGrid 
          externalAutomations={externalAutomationsFiltered} 
          showMore={true} 
          chunk={9} 
        />
      </div>
    </div>
  )
}
